export const BREAKDOWNS_TEAM_BALANCE_FALLBACK = { basic: { assigned: 0 }, advanced: { assigned: 0 } } as const;
export const BREAKDOWNS_USER_BALANCE_FALLBACK = { basic: { assigned: 0, unassigned: 0 }, advanced: { assigned: 0, unassigned: 0 } } as const;
export const BREAKDOWNS_SUPER_ADMIN_BALANCE_FALLBACK = {
  basic: { assigned: 0, unassigned: 0, assignedToUsers: 0 },
  advanced: { assigned: 0, unassigned: 0 },
} as const;

export const BREAKDOWNS_PACKAGE_TYPE = {
  BREAKDOWN_SINGLE_GAME: "1-games",
  BREAKDOWN_FIVE_GAMES: "5-games",
  BREAKDOWN_TEN_GAMES: "10-games",
  BREAKDOWN_TWENTY_GAMES: "20-games",
} as const;

export const BREAKDOWNS_ACTIONS = {
  ASSIGN: "assign",
  UNASSIGN: "unassign",
  PURCHASE: "purchase",
  ADD: "add",
} as const;

export const BREAKDOWNS_ACTIONS_PARAMS = [BREAKDOWNS_ACTIONS.ASSIGN, BREAKDOWNS_ACTIONS.UNASSIGN];

export const BREAKDOWNS_TYPES = {
  BASIC: "basic",
  ADVANCED: "advanced",
} as const;

export const BREAKDOWNS_STATUS = {
  ASSIGNED: "assigned",
  UNASSIGNED: "unassigned",
  PENDING: "pending",
  COMPLETED: "completed",
  FAILED: "failed",
  LOGGING: "logging",
} as const;

export const BREAKDOWNS_CATEGORIES = {
  CUSTOM: "custom",
  PRE_PAID: "pre-paid",
  POST_PAID: "post-paid",
} as const;
